module.exports = __webpack_public_path__ + "static/media/9get.ec80a7a8.svg";